import ApiClient from './ApiClient';

class HISTORICTYPESAPI extends ApiClient {
  constructor() {
    super('historic_types', { accountScoped: true });
  }
}

export default new HISTORICTYPESAPI();
